var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-card"},[(_vm.isDownloading)?_c('div',{staticClass:"download-mask"},[_vm._m(0)]):_vm._e(),_c('div',{staticClass:"action-buttons"},[_c('el-button',{attrs:{"loading":_vm.isDownloading},on:{"click":_vm.downloadClick}},[_vm._v("下载")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mask-content"},[_c('i',{staticClass:"el-icon-loading"}),_c('p',[_vm._v("正在下载中，请稍候...")])])
}]

export { render, staticRenderFns }